import { render, staticRenderFns } from "./QualityExamine.vue?vue&type=template&id=32b91152&scoped=true"
import script from "./QualityExamine.vue?vue&type=script&lang=ts"
export * from "./QualityExamine.vue?vue&type=script&lang=ts"
import style0 from "./QualityExamine.vue?vue&type=style&index=0&id=32b91152&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b91152",
  null
  
)

export default component.exports